import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getAllBrandsLink } from "@faire/retailer-visitor-shared/consts/allBrandsLinks";
import { categoryPath } from "@faire/retailer-visitor-shared/paths/category/categoryPath";
import { getCategoryDisplayName } from "@faire/retailer-visitor-shared/services/Categories";
var IDEAL_REVIW_LENGTH = 160;
export var getMetaDescription = function(brandReviews, baseDescription) {
    var _brandReviewTile_review;
    var brandReviewTile = brandReviews === null || brandReviews === void 0 ? void 0 : brandReviews.sort(reviewSort)[0];
    if ((brandReviewTile === null || brandReviewTile === void 0 ? void 0 : (_brandReviewTile_review = brandReviewTile.review) === null || _brandReviewTile_review === void 0 ? void 0 : _brandReviewTile_review.review_comment) !== undefined) {
        return brandReviewTile.review.review_comment;
    } else {
        return baseDescription;
    }
};
var reviewSort = function(a, b) {
    var _a_review_review_comment, _a_review, _b_review_review_comment, _b_review;
    var _a_review_review_comment_length, _b_review_review_comment_length;
    var lengthDifference = Math.abs(((_a_review_review_comment_length = (_a_review = a.review) === null || _a_review === void 0 ? void 0 : (_a_review_review_comment = _a_review.review_comment) === null || _a_review_review_comment === void 0 ? void 0 : _a_review_review_comment.length) !== null && _a_review_review_comment_length !== void 0 ? _a_review_review_comment_length : Number.MAX_VALUE) - IDEAL_REVIW_LENGTH) - Math.abs(((_b_review_review_comment_length = (_b_review = b.review) === null || _b_review === void 0 ? void 0 : (_b_review_review_comment = _b_review.review_comment) === null || _b_review_review_comment === void 0 ? void 0 : _b_review_review_comment.length) !== null && _b_review_review_comment_length !== void 0 ? _b_review_review_comment_length : Number.MAX_VALUE) - IDEAL_REVIW_LENGTH);
    if (lengthDifference === 0) {
        var _b_review1, _a_review1;
        var _b_review_average_rating, _a_review_average_rating;
        return ((_b_review_average_rating = (_b_review1 = b.review) === null || _b_review1 === void 0 ? void 0 : _b_review1.average_rating) !== null && _b_review_average_rating !== void 0 ? _b_review_average_rating : 0) - ((_a_review_average_rating = (_a_review1 = a.review) === null || _a_review1 === void 0 ? void 0 : _a_review1.average_rating) !== null && _a_review_average_rating !== void 0 ? _a_review_average_rating : 0);
    } else {
        return lengthDifference;
    }
};
export var getCategoryBreadcrumbOptions = function(category, strictLocalize, routingContext, selectedFilterName) {
    var breadCrumbOptions = getBreadCrumb(category, [
        category.urlId
    ], [], strictLocalize, routingContext);
    if (selectedFilterName) {
        breadCrumbOptions.push({
            label: selectedFilterName,
            path: undefined
        });
    }
    // last breadcrumb should not have a path
    var lastBreadcrumbOption = breadCrumbOptions[breadCrumbOptions.length - 1];
    if (lastBreadcrumbOption) {
        lastBreadcrumbOption.path = undefined;
    }
    return breadCrumbOptions;
};
var getBreadCrumb = function(category, categoryUrlIds, breadCrumbOptions, strictLocalize, routingContext) {
    var path = category.isNewProductsC1 || category.isAllBrands ? getAllBrandsLink() : categoryPath({
        urlIds: categoryUrlIds,
        routingContext: routingContext
    });
    breadCrumbOptions.push({
        label: getCategoryDisplayName(category.name, strictLocalize),
        path: path
    });
    if (category.subCategory) {
        return getBreadCrumb(category.subCategory, _to_consumable_array(categoryUrlIds).concat([
            category.subCategory.urlId
        ]), breadCrumbOptions, strictLocalize, routingContext);
    }
    return breadCrumbOptions;
};
